import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useStore } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { COBStep } from '../../ClientOnboarding.common.utils';
import { getInitialSelectedPaymentMethod } from '../../ClientOnboarding.utils';
import { useCobStorage } from '../../CobStorageContext';
export const PaymentMethodContext = createContext(undefined);
export function usePaymentMethodContext() {
    const context = useContext(PaymentMethodContext);
    if (!context) {
        throw new Error('usePaymentMethodContext must be used within PaymentMethodContext.Provider');
    }
    return context;
}
export function usePaymentMethodSelection(param) {
    let { relationship, currentStep, isPreview } = param;
    const userId = useStore(selectors.user.id);
    const { getFromStorage, setToStorage } = useCobStorage(relationship);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(()=>getInitialSelectedPaymentMethod(getFromStorage, relationship, userId));
    const onSelectPaymentMethod = useCallback((pm)=>{
        setSelectedPaymentMethod(pm);
        if (pm) {
            setToStorage('selected_payment_method', pm);
        }
    }, [
        setToStorage
    ]);
    const isOnPaymentMethodStep = currentStep === COBStep.paymentMethod;
    const hasSelectedPayment = !!(selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.fundingSourceId);
    const isPaymentMethodNextDisabled = useMemo(()=>{
        if (!isOnPaymentMethodStep) return false;
        if (isPreview) return false;
        return !hasSelectedPayment;
    }, [
        isOnPaymentMethodStep,
        isPreview,
        hasSelectedPayment
    ]);
    const paymentMethodContextValue = useMemo(()=>({
            selectedPaymentMethod,
            onSelectPaymentMethod
        }), [
        selectedPaymentMethod,
        onSelectPaymentMethod
    ]);
    return {
        selectedPaymentMethod,
        onSelectPaymentMethod,
        isPaymentMethodNextDisabled,
        paymentMethodContextValue
    };
}
